"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUESTION_ATTACHMENT_REFERENCE_TYPES = void 0;
exports.isQuestionAttachmentReference = isQuestionAttachmentReference;
exports.dedupeQuestionAttachmentReferences = dedupeQuestionAttachmentReferences;
exports.QUESTION_ATTACHMENT_REFERENCE_TYPES = ['file', 'creative'];
function isQuestionAttachmentReference(value) {
    if (!value || typeof value !== 'object')
        return false;
    const candidate = value;
    return ((candidate.type === 'file' || candidate.type === 'creative') &&
        typeof candidate.uuid === 'string' &&
        candidate.uuid.length > 0);
}
function dedupeQuestionAttachmentReferences(references) {
    const seen = new Set();
    return references.filter((reference) => {
        const key = `${reference.type}:${reference.uuid}`;
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
